import React from 'react';
import ReactDOM from 'react-dom/client';
import './Styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

const rootDom = document.getElementById('root');
const root = ReactDOM.createRoot(rootDom);
root.render(
	<React.StrictMode>
		<React.Suspense fallback="loading">
			<App />
		</React.Suspense>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
